import { toast } from "react-toastify";
import { chainID, MARKET_FEE } from "../../config/config";

export const onHandleNFTsellAction = async(keychain, nft, price, priceSymbol, currentNftSymbol) => {
    console.log('[debug] onHandleNFTsellAction: ', nft, price, priceSymbol);

    let data = {
        "contractName": "nftmarket",
        "contractAction": "sell",
        "contractPayload": {
            "symbol": currentNftSymbol,
            "nfts": [
                nft._id.toString()
            ],
            "price": price.toString(),
            "priceSymbol": priceSymbol,
            "fee": MARKET_FEE
        },
        "memo": "This is an optional extra field"
    };

    keychain.requestCustomJson(nft.account, chainID, "Active", JSON.stringify(data), "Sell NFT", function(response) {
        if (response.success && response.result) {
            //show modal
            toast.success('NFT sale broacasted!')
        } else {
            //show modal
            toast.error('Oops, the NFT sale failed!')
        }
    });
}

export const onHandleNFTBulkSellAction = async(keychain, account, nfts, price, priceSymbol, currentNftSymbol) => {
    console.log('[debug] onHandleNFTBulkSellAction', nfts, price, priceSymbol);

    let data = {
        "contractName": "nftmarket",
        "contractAction": "sell",
        "contractPayload": {
            "symbol": currentNftSymbol,
            "nfts": nfts.map(String), // convert to array of string
            "price": price.toString(),
            "priceSymbol": priceSymbol,
            "fee": MARKET_FEE
        },
        "memo": "This is an optional extra field"
    };

    keychain.requestCustomJson(account, chainID, "Active", JSON.stringify(data), "Sell NFT", function(response) {
        if (response.success && response.result) {
            //show modal
            toast.success('NFT sell success!')
        } else {
            //show modal
            toast.error('Oops, the NFT sale failed!')
        }
    });
};

export const onHandleNFTTransferAction = async(keychain, account, nfts, toUser, currentNftSymbol, cback = () => {}) => {
    console.log('[debug] onHandleNFTTransferAction', nfts, toUser);

    let data = {
        "contractName": "nft",
        "contractAction": "transfer",
        "contractPayload": {
            "to": toUser,
            "nfts": [{
                "symbol": currentNftSymbol,
                "ids": nfts.map(String)
            }], // convert to array of string
        }
    };

    keychain.requestCustomJson(account, chainID, "Active", JSON.stringify(data), "Transfer NFT", function(response) {
        let isOk = true;
        if (response.success && response.result) {
            console.debug('NFT Transfer result:', response.result);
            //show modal
            toast.success('NFT Transfer broadcasted!')
        } else {
            //show modal
            toast.error('Oops, the NFT Transfer failed!')
            isOk = false;
        }
        cback(isOk);
    });
};
